var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCheck = function SvgCheck(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7803 0.799748C18.0732 1.09264 18.0732 1.56752 17.7803 1.86041L6.43658 13.2042C6.14369 13.4971 5.66881 13.4971 5.37592 13.2042L0.21967 8.04791C-0.0732233 7.75501 -0.0732233 7.28014 0.21967 6.98725C0.512563 6.69436 0.987437 6.69436 1.28033 6.98725L5.90625 11.6132L16.7197 0.799748C17.0126 0.506855 17.4874 0.506855 17.7803 0.799748Z",
    fill: "#198038"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43ODAzIDAuNzk5NzQ4QzE4LjA3MzIgMS4wOTI2NCAxOC4wNzMyIDEuNTY3NTIgMTcuNzgwMyAxLjg2MDQxTDYuNDM2NTggMTMuMjA0MkM2LjE0MzY5IDEzLjQ5NzEgNS42Njg4MSAxMy40OTcxIDUuMzc1OTIgMTMuMjA0MkwwLjIxOTY3IDguMDQ3OTFDLTAuMDczMjIzMyA3Ljc1NTAxIC0wLjA3MzIyMzMgNy4yODAxNCAwLjIxOTY3IDYuOTg3MjVDMC41MTI1NjMgNi42OTQzNiAwLjk4NzQzNyA2LjY5NDM2IDEuMjgwMzMgNi45ODcyNUw1LjkwNjI1IDExLjYxMzJMMTYuNzE5NyAwLjc5OTc0OEMxNy4wMTI2IDAuNTA2ODU1IDE3LjQ4NzQgMC41MDY4NTUgMTcuNzgwMyAwLjc5OTc0OFoiIGZpbGw9IiMxOTgwMzgiLz4KPC9zdmc+Cg==";